export const ListQueryKey = 'activityHllqConfigs';
export const DetailQueryKey = 'activityHllqConfig';
export const Urls = {
  selectUrl: '/rewardCenterConfig/list',
  updateUrl: '/rewardCenterConfig/update',
  deleteUrl: '/rewardCenterConfig/delete',
  createUrl: '/rewardCenterConfig/create',
  detailUrl: '/rewardCenterConfig/detail'
}; // /api/rewardCenterConfig/create